import Validate from './Validate.js';
import { LockScroll } from './LockScroll.js';


class Form {
    constructor(form) {
        this.$form = $(form);
        this.$outer = this.$form.closest('.js-form-outer');
        this.$btn = this.$form.find('.js-submit');
        this.$subscribeMessage = this.$form.find('.js-subscribe-active-message');
        // this.recaptcha;
        this.formFlag = false;
        this.formSendFlag = false;
        this.lockScroll = new LockScroll;
        this.validateObj = '';

        this.popLabels();
        this.validate();
        // this.initRecaptcha();
        this.bindSubmit();
        this.bindEvents();
        // this.bindAgree();
        this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        this.filterPhone();
        this.filterName();
        this.textareaAutoSize();
        this.spamCheck();
        this.bindDropdown();
        this.projectSelect();

        App.D.on('form:reset', () => {
            this.resetForm();
        });
    }



    // Валидация
    validate() {
        this.validateObj = new Validate(this.$form);
    }



    // Инициализируем рекапчу
    /*initRecaptcha() {
        const $container = this.$form.find('.js-recaptcha');

        this.recaptcha = grecaptcha.render($container.attr('id'), {
            'sitekey': $container.data('sitekey'),
            'size': 'invisible',
            'callback': () => {
                this.sendForm();
            },
            'error-callback': () => {
                console.log('recaptcha error');
            }
        });
    }*/



    // Событие отправки
    bindSubmit() {
        //this.$form.on('submit', (e) => {
        this.$form
            .off('submit')
            .on('submit', (e) => {
            e.preventDefault();

            // Запускаем проверку рекапчи
            // grecaptcha.execute(this.recaptcha);

            if (this.formSendFlag) {
                return false;
            }

            this.sendForm();
        });
    }



    // Отправка
    sendForm() {
        if (!this.validateObj.validateAllFields() || this.formSendFlag) {
            return false;
        }

        // проверяем форму подписки на расссылку - если уже подписаны (есть запись в localstorage) то выводим сообщение от том что подписка уже оформлена
        if(this.$form.hasClass('js-subscribe-popup-form') && this.$form.closest('.js-popup-bottom').hasClass('subscribe-active')) {
            this.$subscribeMessage.addClass('_active');
            setTimeout(() => {
                this.$subscribeMessage.removeClass('_active');
            }, 3000);
            return false;
        }

        // Блокируем кнопку сабмита
        this.$btn.prop('disabled', true);
        this.$btn.addClass('_disabled');
        this.formSendFlag = true;

        this.$form.ajaxSubmit({
            url: this.$form.attr('action'),
            dataType: 'json',
            //data: this.$form.serialize(),
            type: this.$form.attr('method') || 'GET',
            // type: 'GET',
            cache: false,
            success: (response) => {
                if (!response.success) {
                    console.log('Ошибка отправки формы');
                    // Ошибка на сервере
                    // this.$form

                    this.$outer
                        .removeClass('_success')
                        .addClass('_error');

                    this.$outer.find('.js-ajax-error').html(response.message ? response.message : 'Ошибка отправки формы');
                    this.$outer.find('.js-ajax-error').closest('.js-input-wrap').addClass('_error-wrap');

                    setTimeout(() => {
                        // Разблокируем кнопку
                        this.$btn.removeAttr('disabled');
                        this.$btn.removeClass('_disabled');
                        this.formSendFlag = false;
                    }, 500);

                    // Автоматически закрываем сообщения
                    setTimeout(() => {
                        // this.$form.removeClass('_success _error');
                        this.$outer.removeClass('_success _error');
                        this.$outer.find('.js-ajax-error').closest('.js-input-wrap').removeClass('_error-wrap');
                        this.$outer.find('.js-ajax-error').html(this.$outer.find('.js-ajax-error').data('default-error'));
                        App.H.removeClass('_form-success');
                    }, 5000);

                } else {
                    // Успех!
                    let answersArray = this.$form.serializeArray();
                    let answersJson = {};

                    // if (this.$form.attr('id') !== 'order-form-3') {
                        $(answersArray).each(function(index, obj) {
                            if (answersJson.hasOwnProperty(obj.name)) {
                                answersJson[obj.name].push(obj.value);
                            } else {
                                if (obj.name === 'project' || obj.name === 'project[]' || obj.name === 'aboutus[]') {
                                    answersJson[obj.name] = obj.value.split('.');
                                } else {
                                    answersJson[obj.name] = obj.value;
                                }
                            }
                        });

                        if (this.$form.is('.form-design-accompaniment')) {
                            window.dataLayer.push({
                                "event": this.$form.data('datalayer') ? this.$form.data('datalayer') : '',
                            });
                        } else {
                            window.dataLayer.push({
                                //"event": "order_form_submit_data",
                                "event": this.$form.data('datalayer') ? this.$form.data('datalayer') : '',
                                "json_data": answersJson
                            });
                        }
                        

                        // если форма подписки, то сохраняем в localStorage флаг, чтобы не показывать в дальнейшем форму подписки уже подписавшимся
                        if (this.$form.is('.subscribe-popup-form')) {
                            localStorage.setItem('isSubscribe', 'true');
                        }
                    // }

                    this.resetForm();
                    this.$btn.removeAttr('disabled');
                    this.$btn.removeClass('_disabled');
                    this.formSendFlag = false;

                    // this.$form
                    this.$outer
                        .removeClass('_error')
                        .addClass('_success');

                    App.H.addClass('_form-success');
                }

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                    // this.$form.removeClass('_success _error');
                    // this.$outer.removeClass('_success _error');
                // }, 5000);
            },
            error: () => {
                // Ошибка запроса
                console.log('Ошибка запроса');
                // this.$form
                this.$outer
                    .removeClass('_success')
                    .addClass('_error');

                this.$outer.find('.js-ajax-error').html('Ошибка запроса');
                this.$outer.find('.js-ajax-error').closest('.js-input-wrap').addClass('_error-wrap');

                App.H.removeClass('_form-success');

                setTimeout(() => {
                    // Разблокируем кнопку
                    this.$btn.removeAttr('disabled');
                    this.$btn.removeClass('_disabled');
                    this.formSendFlag = false;
                }, 500);

                // Автоматически закрываем сообщения
                setTimeout(() => {
                    // this.$form.removeClass('_success _error');
                    this.$outer.removeClass('_success _error');
                    App.H.removeClass('_form-success');

                    this.$outer.find('.js-ajax-error').closest('.js-input-wrap').removeClass('_error-wrap');
                    this.$outer.find('.js-ajax-error').html(this.$outer.find('.js-ajax-error').data('default-error'));
                }, 5000);
            }
        });

        // Генерируем событие для аналитики
        App.D.trigger('ga:sendForm');
    }



    // Открытие и закрытие формы
    bindEvents() {
        $('.js-open-form').on('click', (e) => {
            e.preventDefault();

            if (this.formFlag) { return; }

            this.open();

            // if (App.formIsOpen) {
            //     this.close();
            // } else {
            //     this.open();
            // }
        });

        $('.js-close-form').on('click', () => {
            this.close();
        });

        App.W.on('form:close', () => {
            this.close();
        });

        // Закрыть меню клавишей Escape
        App.W.on('keydown.form', (e) => {
            if (App.formIsOpen && e.keyCode == 27) {
                this.close();
            }
        });



        this.$form
            .find('.js-form-ok')
            .on('click', (e) => {
                e.preventDefault();
                // this.$form.removeClass('_success _error');
                this.$outer.removeClass('_success _error');
            });


        this.$form
            .find('.js-checkbox-more')
            .on('click', (e) => {
                e.preventDefault();
                $('.js-checkbox').addClass('form__checkbox--show-all');
            });
    }



    // Открываем
    open() {

        if (this.formFlag) { return; }
        this.formFlag = true;

        if (App.menuIsOpen) {
            App.W.trigger('menu:close');
        }

        App.H.addClass('_form-open');


        setTimeout(() => {
            this.lockScroll.lock();
        }, 500);

        setTimeout(() => {
            this.formFlag = false;
        }, 1000);

        App.formIsOpen = true;


        // Ставим фокус на первую ссылку (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                $('.js-form-layout').find('a:eq(0)').focus();
            }, 1000);
        }
    }



    // Закрываем
    close() {

        if (this.formFlag) return;
        this.formFlag = true;

        App.H.removeClass('_form-open');

        this.lockScroll.unlock();

        setTimeout(() => {
            this.formFlag = false;
        }, 300);

        setTimeout(() => {
            this.formFlag = false;
        }, 1000);

        App.formIsOpen = false;

        $('.js-form-dropdown-list').slideUp();
        $('.js-form-dropdown').removeClass('_opened');

        setTimeout(() => {
            this.$outer
                .removeClass('_success')
                .removeClass('_error');

            App.H.removeClass('_form-success');
        }, 300);

        // Возвращаем фокус на бургер (для Tab-навигации)
        /*if (!App.mobile) {
            $('.js-burger').focus();
        }*/
    }



    // Загрузка файла
    fileUpload() {
        this.$form
            .find('.js-upload')
            .on('change', (e) => {
                const $input = $(e.target);
                const $inputWrap = $input.closest('.js-input-wrap');
                const inputId = $input.attr('id');
                const val = $input.val();
                const $label = this.$form.find(`.js-upload-label[data-upload="${inputId}"]`);
                const $trigger = this.$form.find(`.js-upload-trigger[for="${inputId}"]`);
                let fileName;

                if (val.length) {
                    fileName = val.split('\\').pop() || '';
                    $label.text(fileName);
                    $input.addClass('_active');
                    $inputWrap.addClass('_active');
                    $trigger.addClass('_active');
                } else {
                    $label.text($label.data('text'));
                    $input.removeClass('_active');
                    $inputWrap.removeClass('_active');
                    $trigger.removeClass('_active');
                }
            });


        this.$form
            .find('.js-upload-clear')
            .on('click', function () {
                const fileId = $(this).siblings('.js-upload-label').data('upload');

                $('#' + fileId).val('').change();
            });


        // Делаем лейблы доступными с клавиатуры
        this.$form.find('.js-upload-trigger').on('keydown', function(e) {
            if (e.keyCode == 32 || e.keyCode == 13) {
                $(this).click();
            }
        });
    }

    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find('[data-phone]').on('input', function () {
            const val = $(this).val().replace(/[^0-9\s()+-]/g, '');
            $(this).val(val);
        });

        // В edge не срабатывает change нпосле потери фокуса
        if (Sniff.browser.name == 'edge') {
            this.$form.find('[data-phone]').on('blur', function () {
                $(this).change();
            });
        }
    }

    // В поле имени разрешаем вводить только буквы
    filterName() {
        this.$form.find('#formname').on('input', function () {
            const val = $(this).val().replace(/[^a-zA-Zа-яА-ЯЁё\s]/g, '');
            $(this).val(val);
        });
    }

    // Раскрывающийся селект
    bindDropdown() {
        this.$form.find('.js-form-dropdown').each(function () {
            const $dropdown = $(this);
            const $input = $dropdown.siblings('.js-input');
            const $current = $dropdown.find('.js-form-dropdown-current');
            const currentEmpty = $current.data('empty');
            const $list = $dropdown.find('.js-form-dropdown-list');
            const $items = $list.children();

            if(!$input.val()) {
                $current.text(currentEmpty);
                $dropdown.removeClass('_placeholder-up');
            }

            $current.unbind().on('click', function () {
                $dropdown.toggleClass('_opened', !$dropdown.is('._opened'));
                $list.toggle();
            });

            $dropdown.on('keydown', function (e) {
                if (e.keyCode == 32 || e.keyCode == 13) {
                    e.preventDefault();
                    if ($current[0] == e.target) {
                        $current.click();
                    }
                    if ($(e.target).is('[data-value]')) {
                        $current.click();
                        $(e.target).click();
                    }
                }
            });

            $items.on('click', function () {
                $dropdown.removeClass('_opened');
                $list.hide();
                $current.text($(this).text());
                $dropdown.addClass('_placeholder-up');
                $input.val($(this).data('value')).change();
            });

            // Закрываем по внешнему клику
            App.W.off('click.dropdown').on('click.dropdown', (e) => {
                if ($(e.target).closest('.js-form-dropdown').length === 0) {
                    $dropdown.removeClass('_opened');
                    $list.hide();
                }
            });
        });
    }

    // bindAgree() {
    //     this.$form.find('.js-form-agree').on('change',  (e) => {
    //         if ($(e.target).is(':checked')) {
    //             this.$btn.attr('disabled', false);
    //             this.validateObj.validateAllFields();
    //         } else {
    //             this.$btn.attr('disabled', true);
    //         }
    //     });
    // }

    // Сброс формы
    resetForm() {
        App.H.removeClass('_form-success');
        this.$form[0].reset();

        this.$form
            .find('.js-upload')
            .val('')
            .change()
            .siblings('[data-label]')
            .text('');

        // this.$form.removeClass('_success _error');

        this.$form
            .find('[data-required]')
            .not(':checkbox')
            .addClass('_notvalidated')
            .removeClass('_error');

        this.$form
            .find(':checkbox[data-required]')
            .not(':checked')
            .addClass('_notvalidated');

        // this.$form
        //     .find('.js-submit')
        //     .attr('disabled', true);

        this.$form
            .find('.js-input-wrap')
            .removeClass('_focused');

        this.$form
            .find('.js-dropdown')
            .trigger('dropdown:reset');

        this.$form
            .find('.js-form-dropdown-current')
            .text($('.js-form-dropdown-current').data('empty'));

        this.$form.find('.js-project-select').val(null).trigger('change.select2');
        this.$form.find('._placeholder-up').removeClass('_placeholder-up');

        // grecaptcha.reset(this.recaptcha);
    }



    // Подсказки для инпутов
    popLabels() {
        this.$form
            .find('input.js-input, textarea.js-input')
            .on('input blur', function () {
                const val = $.trim($(this).val());

                if (!val.length || val == '+7() --') {
                    $(this).closest('.js-input-wrap').removeClass('_focused');
                } else {
                    $(this).closest('.js-input-wrap').addClass('_focused');
                }
            });
    }



    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find('[type="text"], [type="email"], [type="tel"], [type="password"]')
            .filter(':not(.allow-autocomplete)')
            .attr('autocomplete', 'new-password');
    }



    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }



    // Автоматическая высота textarea
    textareaAutoSize() {
        this.$form.find('.js-autosize').each(function() {
            autosize( $(this) );
        });
    }


    // Выбор типа проекта
    projectSelect() {
        this.$form.find('.js-project-select').select2({
            multiple: true,
            width: 'resolve',
            selectionCssClass: 'form__select-container',
            dropdownCssClass: 'form__select-dropdown',
            dropdownParent: $('.form__project-select'),
            language: 'ru',
            closeOnSelect: false
        }).on("select2:selecting", function() {
            $(this).addClass('_placeholder-up');
        }).on("select2:unselecting", function() {
            $(this).removeClass('_placeholder-up');
        }).on('select2:open', function (e) {
            const evt = "scroll.select2";
            $(e.target).parents().off(evt);
            $(window).off(evt);
        });
    }



    // Защита от спама
    spamCheck() {
        App.secondsOnPage = 0;

        // Проверка phantomJS
        let isBot = function() {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true;  //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }


        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        let name = this.$form.data('name');

        //this.$form.append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);
        if (!this.$form.find('.js-input-seconds').length) {
            this.$form.append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);
        }

        clearInterval(App.antispamTimeout);

        App.antispamTimeout = setInterval(() => {
            App.secondsOnPage++;
            //this.$form.find('.js-input-seconds').val(App.secondsOnPage);
            $('.js-input-seconds').val(App.secondsOnPage);
        }, 1000);
    }
}



/*if ($('.js-form').length) {
    App.W.on('grecaptchaLoaded', function () {
        $('.js-form').each(function () {
            new Form(this);
        });
    });
}*/

let forms = [];

App.W.on('barba:afterEnter', () => {
    $('.js-form').each(function () {
        forms.push(new Form(this));
    });
});

App.W.on('barba:leave', () => {
    try {
        for (form of forms) {
            form.destroy();
        }
    } catch(error) { }
});


$('.js-show-more-tags').click(function (e) {
    e.preventDefault();
    const $el = $(this);
    $el.toggleClass("_active");
    
    if ($el.hasClass("_active")) {
        $el.closest(".service-list").addClass("_active");
        $el.text($el.attr("data-text-hide"));
    } else {
        $el.closest(".service-list").removeClass("_active");
        $el.text($el.attr("data-text-show"));
    }
});




// WEBPACK FOOTER //
// ./_src/js/modules/Form.js